import React from 'react';
import './SprichwortFirstHalf.css';

const SprichwortFirstHalf = ({ text }) => {
  return (
    <div className="sprichwort-first-half">
      <span className="sprichwort-text">{text}</span>
    </div>
  );
};

export default SprichwortFirstHalf;

